import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import SocialAnalyticsDashboard from '../../../components/siteadmin/SocialAnalyticsDashboard';

const title = 'Social Media Analytics';

export default async function action({ store }) {

    // Check Authentication
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }

    return {
        title,
        component: <AdminLayout><SocialAnalyticsDashboard title={title} /></AdminLayout>,
    };
};
